module.exports = "/dist/assets/images/pattern.png";